import React from "react";
import { useNavigate } from "react-router-dom";
import { tileImageById } from "../components/quick-actions";
import FeatureHeader from "../components/FeatureHeader";  
import BottomNavigation from "../components/bottom_navigation";

const allFeatures = [
  { id: "symptom-check", title: "Checker", route: "symptom-checker", subtitle: "Check your symptoms", color: "#ef9144" },
  { id: "consult", title: "Doctor", route: "doctor-consult", subtitle: "Live chat or video", color: "#22c55e" },
  { id: "orders", title: "Shop", route: "epharmacy", subtitle: "Medicine, cosmetics & more", color: "#a855f7" },
  { id: "labs", title: "Lab", route: "lab-tests", subtitle: "Book Test, view reports", color: "#3b82f6" },
  { id: "wallet", title: "Wallet", route: "health-wallet", subtitle: "Save, Pay & Insure", color: "#ef4444" },
  { id: "monitor", title: "Monitor", route: "remote", subtitle: "Chronic care tracking", color: "#22c55e" },
  { id: "records", title: "Records", route: "my-health-records", subtitle: "Secure Health files", color: "#a855f7" },
  { id: "learn", title: "Learn", route: "blogs", subtitle: "Easy health education", color: "#22c55e" },
  { id: "emergency", title: "Abulance", route: "emergency-response", subtitle: "Quick emergency response", color: "#ef4444" },
  { id: "campaigns", title: "Campaigns", route: "campaigns", subtitle: "Health drives & offers", color: "#f59e0b" },
];

export default function AllFeatures() {
  const navigate = useNavigate();

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--bg)",
        padding: "0px 16px 112px",
        position: "relative",
      }}
    >
  
      <div style={{ maxWidth: 900, margin: "0 auto" }}>
    
            <FeatureHeader 
        title="Services"
        subtitle="Choose any service below to continue."
        onBack={() => navigate(-1)}
      />
        <div
          style={{
            display: "grid",
            gridTemplateColumns: "repeat(auto-fit, minmax(170px, 1fr))",
            gap: 14,
          }}
        >
          {allFeatures.map((feature) => (
            <button
              key={feature.id}
              type="button"
              onClick={() => navigate(`/${feature.route}`)}
              style={{
                border: "1px solid #e5eaf2",
                borderRadius: 20,
                background: "#fff",
                padding: 12,
                textAlign: "left",
                cursor: "pointer",
                boxShadow: "0 8px 24px rgba(15, 23, 42, 0.06)",
                display: "flex",
                flexDirection: "column",
                minHeight: 220,
              }}
            >
              <div
                style={{
                  width: "100%",
                  borderRadius: 14,
                  height: 120,
                  background: `${feature.color}1a`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  overflow: "hidden",
                  marginBottom: 12,
                }}
              >
                <img
                  src={tileImageById[feature.id]}
                  alt={feature.title}
                  style={{ width: "100%", height: "100%", objectFit: "cover" }}
                />
              </div>

              <div style={{ fontSize: 16, fontWeight: 700, color: "#0f172a", marginBottom: 6 }}>{feature.title}</div>
              <div style={{ fontSize: 13, color: "#64748b", lineHeight: 1.4 }}>{feature.subtitle}</div>
            </button>
          ))}
        </div>
      </div>

      <BottomNavigation />
    </div>
  );
}
